module.exports = __webpack_public_path__ + "assets/img/Business_img1.c26ff0e0.png";